import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AppComponent } from 'src/app/app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule, MatIconModule, MatSidenavModule, MatListModule, MatButtonModule, MatFormFieldModule, MatInputModule, 
         MatCardModule, MatSnackBarModule, MatTableModule, MatPaginatorModule, MatProgressSpinnerModule, MatTooltipModule,        
         MatSortModule, MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MatGridListModule, MatSelectModule, MatDividerModule,
       } from '@angular/material'; 
import { MatMenuModule } from '@angular/material/menu';       
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { FunctionsService, ClientConfigFactory } from 'src/app/common/services/functions.service';
import { SessionService } from 'src/app/common/services/session.service';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { OutputDataService } from 'src/app/common/services/output-data.service';
import { LoginService } from 'src/app/managers/login.service';
import { RssFeedService } from 'src/app/managers/rssFeed.service';

import { UserRepository } from 'src/app/repositories/user.repository';
import { CategoryRepository } from 'src/app/repositories/category.repository';
import { ChannelItemRepository } from 'src/app/repositories/channelItem.repository';
import { ChannelRepository } from 'src/app/repositories/channel.repository';

import { HomeComponent } from 'src/app/components/home/home.component';
import { LoginComponent } from 'src/app/components/login/login.component';
import { AppMenuComponent } from 'src/app/common/components/app-menu/app-menu.component';
import { AdminComponent } from './components/admin/admin.component';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { SideMenuComponent } from './common/components/side-menu/side-menu.component';
import { AdminMyselfComponent } from './components/admin-myself/admin-myself.component';
import { AdminUsersComponent } from './components/admin-users/admin-users.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { AlertDialogComponent } from './common/components/alert-dialog/alert-dialog.component';
import { AddUserComponent } from './components/add-user/add-user.component';
import { SideChannelMenuComponent } from 'src/app/common/components/side-channel-menu/side-channel-menu.component';
import { RssItemComponent } from './components/rss-item/rss-item.component';
import { EditCategoryComponent } from './components/edit-category/edit-category.component';
import { EditChannelComponent } from './components/edit-channel/edit-channel.component';
import { TodayFeedItemsComponent } from './components/today-feed-items/today-feed-items.component';
import { TodayFeedItemComponent } from './components/today-feed-item/today-feed-item.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';

import { Store } from 'src/app/store/store';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    AppMenuComponent,
    AdminComponent,
    BaseComponent,
    SideMenuComponent,
    AdminMyselfComponent,
    AdminUsersComponent,
    EditUserComponent,
    AlertDialogComponent,
    AddUserComponent,
    SideChannelMenuComponent,
    RssItemComponent,
    EditCategoryComponent,
    EditChannelComponent,
    TodayFeedItemsComponent,
    TodayFeedItemComponent,
    ForgotPasswordComponent,
    MyProfileComponent
  ],
  imports: [
    BrowserModule,  
    BrowserAnimationsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    FlexLayoutModule,
    MatFormFieldModule, 
    MatInputModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTooltipModule,
    MatDialogModule,
    MatGridListModule,
    MatSelectModule,
    MatDividerModule,
    AppRoutingModule,
    MatMenuModule
  ],
  entryComponents: [
    EditUserComponent,
    AlertDialogComponent,
    AddUserComponent,
    EditCategoryComponent,
    EditChannelComponent,
    ForgotPasswordComponent,
    MyProfileComponent
  ],
  providers: [  // DI for singleton
    SessionService,
    LoginService,
    FunctionsService,
    OutputDataService,
    RssFeedService,
    
    UserRepository,
    CategoryRepository,
    ChannelItemRepository,
    ChannelRepository,

    Store,

    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    { provide: ClientConfigService, useFactory: ClientConfigFactory }   
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }